import React, { useEffect, useState } from 'react'
import { apiUrls } from 'constants/apiUrls';
import { Alert, Button, Col, Form, Row } from 'react-bootstrap'
import { BiSave } from 'react-icons/bi';
import { BsX } from 'react-icons/bs';
import { toast } from 'react-toastify';
import { invoiceService } from 'services/invoiceService';
import DatePicker from 'react-datepicker';
import { commonMessage } from 'constants/commonMessage';
import ProgressLoader from 'components/Loader/ProgressLoader';
import { allowNumber, allowNumberDecimal } from 'utils/inputValidator';
import { ddMMyyyy } from 'utils/dateFormatter';

const InvoiceForm = ({
    customerId,
    invoiceId,
    invoiceNo,
    paymentStatus,
    invoiceDate,
    itemsAmount,
    disAmount,
    totalAmount,
    prevBalance,
    gstPerc,
    onSave,
    onCancel
}) => {
    const [isLoader, setIsLoader] = useState(false);
    const [message, setMessage] = useState();
    const [invoiceUpdate, setInvoiceUpdate] = useState({
        id: invoiceId,
        customerId: customerId,
        invoiceNo: invoiceNo,
        paymentStatus: paymentStatus,
        invoiceDate: invoiceDate,
        itemsAmount: itemsAmount,
        disAmount: disAmount,
        totalAmount: totalAmount,
        prevBalance: prevBalance,
        gstPerc: gstPerc,
        isActive: true
    });

    useEffect(() => { }, [invoiceId]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "disAmount" && !allowNumberDecimal(e.target.value)) { return; }
        if (name === "prevBalance" && !allowNumberDecimal(e.target.value)) { return; }
        if (name === "gstPerc" && !allowNumber(e.target.value)) { return; }

        setInvoiceUpdate((preValue) => ({
            ...preValue, [name]: (type === 'checkbox' ? checked : value)
        }));
    }

    const setInvoiceDate = (value) => {
        setInvoiceUpdate((preValue) => ({
            ...preValue, "invoiceDate": value
        }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            setIsLoader(true);
            invoiceService.updateInvoice(apiUrls.updateInvoice(invoiceId), invoiceUpdate).then((res) => {
                setIsLoader(false);
                if (res === true) {
                    toast.success("Invoice updated successfully!");
                    onSave();
                } else {
                    toast.error(commonMessage.somethingWrong());
                }
            }).catch((err) => setIsLoader(false));
        }
    }

    const validateForm = () => {
        setMessage();
        if (!invoiceUpdate.id
            || !invoiceUpdate.customerId
            || !invoiceUpdate.invoiceNo
            || !invoiceUpdate.invoiceDate
            || !(parseFloat(invoiceUpdate.disAmount) >= 0)
            || !(parseFloat(invoiceUpdate.prevBalance) >= 0)
            || !(parseInt(invoiceUpdate.gstPerc) >= 0)) {
            setMessage("All star marked field required!");
            return false;
        }
        return true;
    }

    return (
        <>
            <Row className="justify-content-center">
                <Col md={12}>
                    {isLoader && <ProgressLoader />}
                    {message && (
                        <Alert variant='danger'>
                            {message}
                        </Alert>
                    )}
                    {/* {JSON.stringify(invoiceUpdate)} */}
                    <Form onSubmit={handleSubmit} noValidate>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="4">Invoice No:*</Form.Label>
                            <Col sm="8">
                                <Form.Control
                                    type="text"
                                    maxLength={10}
                                    name='invoiceNo'
                                    value={invoiceUpdate.invoiceNo}
                                    onChange={handleChange} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="4">Invoice Date:*</Form.Label>
                            <Col sm="8">
                                <DatePicker
                                    selected={invoiceUpdate.invoiceDate}
                                    onSelect={setInvoiceDate}
                                    dateFormat={ddMMyyyy}
                                    className="form-control" />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="4">Items Amount</Form.Label>
                            <Col sm="8">
                                <Form.Control
                                    type="text"
                                    maxLength={10}
                                    name='itemsAmount'
                                    value={invoiceUpdate.itemsAmount}
                                    disabled={true} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="4">Discount:*</Form.Label>
                            <Col sm="8">
                                <Form.Control
                                    type="text"
                                    maxLength={10}
                                    name='disAmount'
                                    value={invoiceUpdate.disAmount}
                                    onChange={handleChange} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="4">Prev Balance:*</Form.Label>
                            <Col sm="8">
                                <Form.Control
                                    type="text"
                                    maxLength={10}
                                    name='prevBalance'
                                    value={invoiceUpdate.prevBalance}
                                    onChange={handleChange} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="4">GST %:*</Form.Label>
                            <Col sm="8">
                                <Form.Control
                                    type="text"
                                    maxLength={2}
                                    name='gstPerc'
                                    value={invoiceUpdate.gstPerc}
                                    onChange={handleChange} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Col sm={{ span: 8, offset: 4 }}>
                                <Button
                                    type="submit"
                                    variant='primary'
                                    className='mw-100'>
                                    <BiSave size={20} /> Update
                                </Button>
                                <Button
                                    type="button"
                                    variant='secondary'
                                    className='ms-3 mw-100'
                                    onClick={onCancel}>
                                    <BsX size={20} /> Cancel
                                </Button>
                            </Col>
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
        </>
    )
}

export default InvoiceForm;